export default "/MAGIC.c5b9d97a36ebd07173fc460f76d8018a.svg";